import { render, staticRenderFns } from "./BankProviderSelectorTinkUP.vue?vue&type=template&id=16f7422e&scoped=true&"
import script from "./BankProviderSelectorTinkUP.vue?vue&type=script&lang=js&"
export * from "./BankProviderSelectorTinkUP.vue?vue&type=script&lang=js&"
import style0 from "./BankProviderSelectorTinkUP.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BankProviderSelectorTinkUP.vue?vue&type=style&index=1&id=16f7422e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f7422e",
  null
  
)

export default component.exports